import { ServizioSemplice } from "./servizio-semplice";

export class PacchettoServizio {
  idImmobile: number;
	riferimento: number;
	costo: number;
	servizi: Array<ServizioSemplice>;
	statoPagamento: string;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/pacchetto-servizio.ts